module.exports = __webpack_public_path__ + "img/bg.fe350e57.jpg";